import type { operations } from '@/types/schemas/api.main';
import { POST } from '../../_http';
type controller = operations['CrmApplicationsSubmitApplicationController_post'];

export type CrmSubmitApplicationBody = controller['requestBody']['content']['application/json'];
export type CrmSubmitApplicationResponse = controller['responses']['200']['content']['application/json'];

export const submitApplication = POST('/crm/applications/submit-application')<
  CrmSubmitApplicationBody,
  CrmSubmitApplicationResponse
>;
